import SVG from 'react-inlinesvg';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import IconButton from '@mui/material/IconButton';
import CircleIconSrc from 'src/assets/icons/circle.svg';
import TriangleIconSrc from 'src/assets/icons/triangle.svg';
import styled from 'styled-components';

import RectangleIconSrc from '@/assets/icons/square.svg';
import { FilterOption } from '@/features/canvas/components/FilterOption';
import { components } from '@/types/api';

type FilterMultiOptionProps = {
  filterId: number;
  filterShape: 'circle' | 'square' | 'triangle';
  option: components['schemas']['FilterOption'];
  roadmapId: number;
  attributes?: React.HTMLAttributes<HTMLElement>;
  listeners?: React.DOMAttributes<Element>;
};

const FilterMultiOption = ({
  option,
  filterShape,
  filterId,
  roadmapId,
  attributes,
  listeners,
}: FilterMultiOptionProps) => {
  const getShapeIcon = () => {
    switch (filterShape) {
      case 'triangle':
        return <StyledSVG src={TriangleIconSrc} />;
      case 'square':
        return <StyledSVG src={RectangleIconSrc} />;
      default:
        return <StyledSVG src={CircleIconSrc} />;
    }
  };

  const Icon = getShapeIcon();

  return (
    <OptionRow>
      <DragHandle className="drag-handle" aria-label="Drag" {...attributes} {...listeners}>
        <DragIndicatorIcon fontSize="small" />
      </DragHandle>
      <FilterOption
        key={option.id}
        option={option}
        filterId={filterId}
        roadmapId={roadmapId}
        Icon={Icon}
      />
    </OptionRow>
  );
};

const StyledSVG = styled(SVG)`
  width: 1.4rem;
  height: 1.4rem;
  overflow: visible;
`;

const OptionRow = styled.div<{ $isDragging?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  opacity: ${({ $isDragging }) => ($isDragging ? 0.6 : 1)};
  transform: ${({ $isDragging }) => ($isDragging ? 'scale(0.98)' : 'none')};
`;

const DragHandle = styled(props => <IconButton color="inherit" {...props} />)`
  cursor: grab;
  padding: 0;
  margin-right: 0.5rem;
  color: #707070;

  &:hover {
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;

export { FilterMultiOption };
